import React from 'react'
import { Button } from 'reactstrap'
import styled from 'styled-components'

export const generateButton = (button, click, isEdit) => {
  switch (button) {
    case 'create': {
      return <Button color="success" onClick={ () => click() }>Create</Button>
    }
    case 'success': {
      return <Button color='success' onClick={ () => click() }>OK</Button>
    }
    case 'error': {
      return <Button color='warning' onClick={ () => click() }>Try Again</Button>
    }
    case 'form': {
      return (
        <div>
          <CustomButton
            style={ { width: 100 } }
            outline
            color="danger"
            onClick={ () => click('delete') }
          >
          Delete</CustomButton>
          <CustomButton
            style={ { width: 100 } }
            color='success'
            onClick={ () => click('edit') }
          >
            { isEdit ? 'Save' : 'Edit' }</CustomButton>
        </div>
      )
    }
    case 'discard': {
      return (
        <div>
          <CustomButton onClick={ () => click('no') }>Cancel</CustomButton>
          <CustomButton color='danger' onClick={ () => click('yes') }>Discard</CustomButton>
        </div>
      )
    }
    case 'delete': {
      return (
        <div>
          <CustomButton onClick={ () => click('no') }>Cancel</CustomButton>
          <CustomButton color='danger' onClick={ () => click('yes') }>Delete</CustomButton>
        </div>
      )
    }
    default:
      return null
  }
}

const CustomButton = styled(Button)`
  margin-right: 10px ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
`



// WEBPACK FOOTER //
// ./src/components/client/helpers/button.js